<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { VSearchableMultiSelect } from '@/modules/shared/components'
import { useCandidateStore } from '@/modules/connecting/stores/candidate-store'
import { useWorkspaceOnboardingStore } from '../../stores/workspace-onboarding-store'
import { useUnivesrityStore } from '@/modules/shared/stores/university-store'

const candidateStore = useCandidateStore()
const onboardingStore = useWorkspaceOnboardingStore()
const universityStore = useUnivesrityStore()

const affiliations = ref<string[]>([])

const candidate = computed(() => {
  const id = onboardingStore.workspace?.connecting_candidate_id
  return id ? candidateStore.getCandidate(id.toString()) : undefined
})

watch(
  candidate,
  (c) => {
    if (!c) return
    affiliations.value = [...(c.university_affiliations || [])]
  },
  { immediate: true },
)

const submit = async (): Promise<boolean> => {
  const candidateId = onboardingStore.workspace?.connecting_candidate_id
  if (!candidateId) return false

  await candidateStore.updateCandidate({
    id: candidateId,
    subject_id: onboardingStore.workspace!.id,
    subject_type: 'Group',
    university_affiliations: affiliations.value,
  })
  return true
}

defineExpose({ submit })
</script>

<template>
  <div class="flex flex-1 flex-col">
    <VSearchableMultiSelect
      v-model="affiliations"
      :options="universityStore.us_universities"
      placeholder="Search for a university..."
      empty-message="No universities found"
    />
  </div>
</template>
